<template>
    <div class="container" style="padding-bottom: 30px;">
        <h1 class="title">{{ title }}</h1>

        <h2 class="title">{{ DocVerification }}</h2>

        <div v-if="data != ''" v-for='item in data' class="verItem">
            <label> {{ item.title }} </label>
            <span style="float:right; margin-right: 10px;"> {{ item.value }} </span>
        </div>

        <p class="bottomTitle">
            {{ bottomTitle }}
        </p>
    </div>
</template>
  
<script>
import {
    getCustomerReportData,
} from "../../api/userMG";
export default {
    name: "App",
    data() {
        return {
            CID: "",
            UID: "",
            data: [],
            title: "",
            DocVerification:"",
            bottomTitle:"",
        };
    },
    mounted() {
        if (this.$route.query.CID && this.$route.query.UID) {
            this.CID = this.$route.query.CID;
            this.UID = this.$route.query.UID;
            this.DocVerification = DocVerification;
            this.init();
        }
    },
    methods: {
        init() {
            let that = this;
            let params = {
                CID: this.CID,
                UID: this.UID,
            };
            // 校验手机号
            getCustomerReportData(params).then((res) => {
                if (res.data.code == 100) {
                    let data = res.data.data;
                    that.title = res.data.message;
                    that.bottomTitle = res.data.result;
                    document.title = res.data.message;
                    that.data = data;
                }
            });
        }
    },
};
</script>
  
<style scoped lang="less">
.title {
    text-align: center;
}
.verItem {
    width: 80%;
    border-bottom: 1px solid gray;
    padding: 16px 10px;
    margin: 0 auto;

    label {
        font-size: 18px;
    }

    span {
        font-size: 18px;
    }
}

.container {
    width: 100%;
    position: absolute;
    z-index: -9999;
}

.bottomTitle{
    position: fixed;
    bottom: 0;
    color: gainsboro;
    text-align: center;
    font-size: 18px;
    width: 200px;
    left: 50%;
    margin-left: -100px;
}
</style>
  


// WEBPACK FOOTER //
// src/views/outReport/DocVerification.vue